<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="enlargements"
          :search="search"
          sort-by="created_at"
          sort-desc
          :items-per-page="25"
          :footer-props="{
            itemsPerPageOptions: [-1, 50, 25, 10],
          }"
          @click:row="navigateToEnlargement"
        >
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Vertragserweiterungen</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />

              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="createEnlargement"
              >
                Vertragserweiterung hinzufügen
              </v-btn>
            </v-toolbar>
          </template>
          <template #[`item.start_date`]="{ item }">
            <span>{{ getDateString(item.start_date) }}</span>
          </template>
          <template #[`item.end_date`]="{ item }">
            <span>{{ getDateString(item.end_date) }}</span>
          </template>
          <template #[`item.turnover`]="{ item }">
            {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.turnover) }}
          </template>
          <template #[`item.monthly_turnover`]="{ item }">
            {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.monthly_turnover) }}
          </template>
          <template #[`item.actions`]="{ item }">
            <inertia-link :href="route('offerData.show', item.id)">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    class="mr-3"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>öffnen</span>
              </v-tooltip>
            </inertia-link>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Verträge',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      enlargements: {
         type: Array,
         required: true,
      },
      contract: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         dialog: false,
         statuswahlOffer: null,
         search: '',
         headers: [
            {
               text: 'Status',
               align: 'start',
               filterable: false,
               value: 'status',
            },
            { text: 'Nummer', value: 'number' },
            { text: 'Umsatz', value: 'turnover' },
            { text: 'Umsatz/Monat', value: 'monthly_turnover' },
            { text: 'Startdatum', value: 'start_date' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],

      }
   },

   methods: {
      getDateString (dateVal) {
         return formattedDateString(dateVal)
      },
      createEnlargement () {
         this.$inertia.visit(this.route('contracts.enlargements.create', this.contract))
      },
      navigateToEnlargement (_enlargement) {
         this.$inertia.visit(this.route('offerData.show', _enlargement))
      },
   },
}
</script>
